document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(
    ".grid__item, .card, .product-card"
  );

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        }
      });
    },
    { threshold: 0.2 }
  );

  items.forEach((item, index) => {
    item.classList.add("home-animate");
    item.style.transitionDelay = `${index * 0.1}s`;
    observer.observe(item);
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(
    ".template-index .product-media__image"
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  images.forEach((img, index) => {
    img.classList.add("animate-from-right");
    img.style.transitionDelay = `${index * 0.1}s`;
    observer.observe(img);
  });

});